let ajaxURL = spp.ajaxurl;



export { ajaxURL };